import React, { useState, useEffect } from 'react';

import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';
import { Levels, Spinner } from 'react-activity';

import { faWallet, faCreditCard, faSave, faSync  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import handleMessage from './includes/handle-message.js';
import loadDriver from './includes/load-driver.js';
import getTxHashContext from './includes/get-tx-hash-context.js';
import getWidgetSelf from './includes/get-widget-self.js';
import constructTokenAmount from './includes/construct-token-amount.js';
import getReturnUrl from './includes/get-return-url.js';
import getCallbackUrl from './includes/get-callback-url.js';
import openExplorer from './includes/open-explorer.js';
import openLocalWallet from './includes/open-local-wallet.js';



const WIDGET_NAME = 'payment-link';
const SETTINGS_ENTRY_STUB = 'widget.payment.link.';

const RESERVED_KEY_NAMES = ['route', 'ring', 'web3url', 'cardaddress', 'tokenaddress', 'to', 'amount', 'invoiceid', 'returnurl', 'tx'];

const PaymentLinkWidget = ({app, uuid}) => {
	const theapp = app;
	const widget_uuid = uuid;
	const getWidgetUUID = () => {return widget_uuid;};

	var currentscheme;
	var setCurrentScheme = (scheme) => {currentscheme = scheme};

	var currentcard;
	var setCurrentCard = (card) => {currentcard = card};
	
	var currency;
	var setCurrency = (ccy) => {currency = ccy};

	var ischecking = false;
	var setIsChecking= (val) => { ischecking = val};

	const [isenabled, setIsEnabled] = useState(true);
	const [isloading, setIsLoading] = useState(false);
	const [isprocessing, setIsProcessing] = useState(false);

	const [widgetsize, setWidgetSize] = useState('small');

	const [showlocalwallet, setShowLocalWallet] = useState(true);

	// issuing transaction
	const [amount, setAmount] = useState(0);
	const [amount_string, setAmountString] = useState('');

	const [to_address, setToAddress] = useState(null);
	
	const [invoice_id, setInvoiceId] = useState('');

	const [tx_data, setTransactionData] = useState(null);

	// reporting transaction
	const [tx_info, setTransactionInfo] = useState(null);


	// post rendering functions
	const checkCurrencyContext = async () => {
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let context = {currentscheme, currentcard, currency, _refresh_page: false};

		try {
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

			await theapp.getCurrencyContext(context, settings_entry);

			if (!currentscheme && context.currentscheme)
				setCurrentScheme(context.currentscheme);

			if (!currentcard && context.currentcard)
				setCurrentCard(context.currentcard);

			if (!currency && context.currency)
				setCurrency(context.currency);
		}
		catch(e) {
			console.log('exception in PaymentLinkWidget.checkCurrencyContext: ' + e);
		}

		return context;
	}

	const computeTokenAmount = async (amount) => {
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

		return constructTokenAmount(theapp, settings_entry, amount);
	}



	// 
	const onPay = async () => {

		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		// can proceed
		let canPay = (isenabled ? true : false);

		if ((start_conditions.ask_before_pay === true) || (start_conditions.ask_before_pay === 'true')) {
			// client asked to be consulted
			let answer_struct = await theapp.sendParent({action: 'can_pay'});

			if (answer_struct && (answer_struct.can_pay !== undefined)) 
				canPay = answer_struct.can_pay;
		}

		if (!canPay)
		return;


		// find driver for specified wallet (if any)
		let remotewallet = await loadDriver(theapp);


		if (remotewallet) {
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

			let context = {currentscheme, currentcard, currency};
			await theapp.getCurrencyContext(context, settings_entry);
	
			let _currency = context.currency;
			let _card = context.currentcard;
			let _scheme = context.currentscheme;

			let returnurl = getReturnUrl(theapp);
			let callbackurl = getCallbackUrl(theapp);

			let params = {amount: amount, to_address,  returnurl, callbackurl};

			// currency context
			params.schemeuuid = (_scheme ? _scheme.uuid : null);
			params.web3_provider_url = (_scheme && _scheme.network && _scheme.network.ethnodeserver ? _scheme.network.ethnodeserver.web3_provider_url : null);

			params.carduuid = (_card ? _card.uuid : null);
			params.cardaddress = (_card ? _card.address : null);

			params.currencyuuid = (_currency ? _currency.uuid : null);
			params.currencyaddress = (_currency ? _currency.address : null);

			// transaction info (seller info, description, category,...)
			params.invoice_id = invoice_id;
			params.tx_data = tx_data;

			// driver handles command
			await remotewallet.onPay(params);
		}
		else {
			theapp.alert('no driver found for ' + start_conditions.remote_wallet_driver);
		}

	}

	const onOpenExplorer = async () => {
		console.log('PaymentLinkWidget.onOpenExplorer called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		return openExplorer(theapp, tx_info);
	}

	const onRefresh = async () => {
		theapp.refreshPage();
	}

	const onOpenWallet = async () => {
		console.log('PaymentLinkWidget.onOpenWallet called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;
		
		let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;
		let context = {currentscheme, currentcard, currency};
		await theapp.getCurrencyContext(context, settings_entry);


		return openLocalWallet(theapp, context);
	}

	const onDownloadReceipt = async () => {
		console.log('PaymentLinkWidget.onDownloadReceipt called');

		let mvcmywidget = theapp.getMvcMyWidget();
		let start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let date = mvcmywidget.formatDate(tx_info.time, 'YYYY-mm-dd HH:MM:SS');

		let _cr = '\r\n';
		let receipt_string = 'TRANSACTION RECEIPT' + _cr + _cr;

		receipt_string += 'Amount: ' + tx_info.amount_string + _cr;
		receipt_string += 'Transaction hash: ' + tx_info.hash + _cr;
		receipt_string += 'Date: ' + date + _cr;
		receipt_string += 'Status: ' + getStatusString(tx_info.status_int) + _cr;

		const receipt_span = document.getElementById('receipt-icon');

		const element = document.createElement('a');

		
		// change date to comply with file name constraints
		var filedate = date.replace(' ', '_');
		filedate = filedate.replace(':', 'h');
		filedate = filedate.replace(':', 'm');
		
		const file = new Blob([receipt_string], {type: 'text/plain'});
		element.href = URL.createObjectURL(file);
		element.download = 'receipt-' + filedate + '.txt';
		receipt_span.appendChild(element); // Required for this to work in FireFox
		element.click();
	}

	const onHandleMessage = async (eventname, params) => {
		if (!params)
			return;

		let mutable = theapp.isMutable();
	

		switch(params.action) {
			case 'getWidgetInfo': {
				let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);

				let amount = self.amount;
				let to_address = self.to_address;
				let web3_provider_url = (currentscheme && currentscheme.network && currentscheme.network.ethnodeserver ? currentscheme.network.ethnodeserver.web3_provider_url : null)
				let card_address = (currentcard ? currentcard.address : null);
				let token_address = (currency ? currency.address : null);;

				theapp.answerRequest(params, {amount, to_address, web3_provider_url, card_address, token_address});
			}
			break;

			case 'setAmount':
				if (mutable)
				onAmountChange(params.amount);
				break;
			case 'getAmount': {
					let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);
					theapp.answerRequest(params, {amount: self.amount});
				}
				break;
	
	
			case 'setToAddress':
				if (mutable)
				onToAddressChange(params.address);
				break;
			case 'getToAddress': {
					let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);
					theapp.answerRequest(params, {to_address: self.to_address});
				}
				break;

				
			case 'getCardAddress': {
					if (!currentcard) {
						let context = await checkCurrencyContext();
					}
					let card_address = (currentcard ? currentcard.address : null);
					theapp.answerRequest(params, {card_address});
				}
				break;
			case 'getCardPublicKeys': {
					let public_keys = (currentcard ? currentcard.publickeys : null);
					theapp.answerRequest(params, public_keys);
				}
				break;
			case 'getCardBalance': {
					let mvcmywidget = theapp.getMvcMyWidget();
					let rootsessionuuid = await theapp.getRootSessionUUID();
					let devicewallet = await theapp.getDeviceWallet();
					let walletuuid = devicewallet.uuid;
		
					var card_balance = {};

					// currency balance
					let _pos = await mvcmywidget.getCurrencyPosition(rootsessionuuid, walletuuid, currency.uuid, currentcard.uuid).catch(err => {});
						
					if (_pos !== undefined) {
						let _card_balance_int = await _pos.toInteger();
						let _card_balance_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, _pos);

						card_balance.balance = _card_balance_int;
						card_balance.balance_string = _card_balance_string;
					}

					// transaction units
					let _card_credit_balance = await mvcmywidget.getCardCreditBalance(rootsessionuuid, walletuuid, currentcard.uuid).catch(err => {});

					if (_card_credit_balance) {
						card_balance.transaction_units = _card_credit_balance.transactionunits;
					}

					theapp.answerRequest(params, card_balance);
				}
				break;
				
	
			case 'enableWidget':
				setIsEnabled(true);
				theapp.answerRequest(params, {enabled:true});
				break;
			case 'disableWidget':
				setIsEnabled(false);
				theapp.answerRequest(params, {enabled:false});
				break;
			case 'isEnabled': {
					let flag = (isenabled === true ? true : false)
					theapp.answerRequest(params, {enabled:flag});
				}
				break;
				
			case 'getInvoiceId': {
					let self = getWidgetSelf(theapp, WIDGET_NAME + params.widget_uuid);
					theapp.answerRequest(params,  {invoice_id: self.invoice_id});
				}
				break;

			case 'setInvoiceId':
				onInvoiceIdChange(params.invoiceid);
				break;

			case 'addTransactionData':
				onAddTransactionData(params.data);
				break;
			case 'setTransactionHash':
				onTransactionHashChange(params.transaction_hash);
				break;

			// request for actions
			case 'doOpenWallet': {
				await onOpenWallet();
			}
			break;


			// support api
			default: {
					let start_conditions = theapp.getStartConditions();
					if (!start_conditions) return;
					let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;
					handleMessage(theapp, settings_entry, params);
				}
				break;
		}
	}

	const onRefreshPage = async (eventname, params) => {
		console.log('PaymentLinkWidget.onRefreshPage called');

		if (!ischecking) {
			console.log('calling checkNavigationState after page refresh');
			await checkNavigationState();
		}
		else {
			console.log('ischecking==true, not calling checkNavigationState');
		}

		return;
	}

	const checkNavigationState = async () => {
		console.log('PaymentLinkWidget.checkNavigationState called');

		setIsLoading(true);
		setIsChecking(true);

		let mvcmywidget = theapp.getMvcMyWidget();
		var start_conditions = theapp.getStartConditions();

		if (!start_conditions)
		return;

		let context = {currentscheme, currentcard, currency, _refresh_page: false};

		try {
			var rootsessionuuid = await theapp.getRootSessionUUID();
			var devicewallet = await theapp.getDeviceWallet();
			var walletuuid = devicewallet.uuid;
	
			let settings_entry = SETTINGS_ENTRY_STUB + start_conditions.client_id;

			await theapp.getCurrencyContext(context, settings_entry);

			if (!currentscheme && context.currentscheme)
				setCurrentScheme(context.currentscheme);

			if (!currentcard && context.currentcard)
				setCurrentCard(context.currentcard);

			if (!currency && context.currency)
				setCurrency(context.currency);

			if (start_conditions.caller && currentscheme) {
				let tx_hash = getTxHashContext(theapp);

				if (tx_hash) {
					let remotewallet = await loadDriver(theapp);

					let _tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, tx_hash);

					setTransactionInfo(_tx_info);
				}
			}

			if ((start_conditions.disabled === true) || (start_conditions.disabled === 'true')){
				// specified to start disabled
				setIsEnabled(false);
			}

			if (start_conditions.amount) {
				// a default amount has been set
				onAmountChange(start_conditions.amount);
			}
			else if (start_conditions.string_amount && (start_conditions.string_amount > 0)) {
				let tokenamount = await computeTokenAmount( start_conditions.string_amount);

				if (tokenamount !== undefined)
				onAmountChange(tokenamount);
			}
			
			if (start_conditions.to_address) {
				// a default recipient has been set
				onToAddressChange(start_conditions.to_address);
			}

			if ((start_conditions.local_wallet_hide === true) || (start_conditions.local_wallet_hide === 'true')){
				// specified to hide access to local wallet
				setShowLocalWallet(false);
			}

			if (start_conditions.invoice_id) {
				onInvoiceIdChange(start_conditions.invoice_id);
			}
			else {
				// pre-fill
				let invoiceid = 'INV_' + theapp.guid().substring(0, 8);
				onInvoiceIdChange(invoiceid);
			}



			// widget size
			let widgetsize = theapp.getWidgetSize();

			if (widgetsize != 'small')
			console.log('warning: we handle only the small widget format for the moment!');

			// signal we are loaded
			await mvcmywidget.signalEvent('on_widgetloaded_message', {widget_name: WIDGET_NAME});
		}
		catch(e) {
			console.log('exception in PaymentLinkWidget.checkNavigationState: ' + e);
		}
		finally {
			console.log('final statements in PaymentLinkWidget.checkNavigationState');
			setIsLoading(false);
			setIsChecking(false);

			// refresh page, if required
			if (context._refresh_page)					
			theapp.refreshPage();
		}

	}
  

	useEffect(() => {
		console.log('PaymentLinkWidget.useEffect called');

		var mvcmywidget = theapp.getMvcMyWidget();
		var uuid = mvcmywidget.guid();

		checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err)});

		mvcmywidget.registerEventListener('on_handle_message', uuid, onHandleMessage);
		mvcmywidget.registerEventListener('on_refreshPage', uuid, onRefreshPage);
		return () => {
			mvcmywidget.unregisterEventListener('on_refreshPage', uuid);
			mvcmywidget.unregisterEventListener('on_handle_message', uuid);
		};
	}, []);

	// API
	const onTransactionHashChange = async (txhash) => {
		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		if (!currentscheme) {
			await checkNavigationState();
		}

		let remotewallet = await loadDriver(theapp);

		let _tx_info = await remotewallet.getTransactionInfo(rootsessionuuid, walletuuid, currentscheme.uuid, txhash);

		setTransactionInfo(_tx_info);
	}

	// user inputs
	const putAmount = (amnt, widgetuuid) => {
		setAmount(amnt);

		// save in widget self
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		self.amount = amnt;
	}

	const onAmountChange = async (amnt) => {
		let start_conditions = theapp.getStartConditions();

		if (start_conditions && (start_conditions.amount) && (start_conditions.amount != amnt))
		return; // default has been set and can not be modified for security reasons
		
		if (!currency)
			return;

		var mvcmywidget = theapp.getMvcMyWidget();

		var rootsessionuuid = await theapp.getRootSessionUUID();
		var devicewallet = await theapp.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		// we can check valid amount

		// format to currency
		const currency_amount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currency.uuid, amnt);
		var options = {showdecimals: true, decimalsshown: 4}
		const currency_amount_string = await mvcmywidget.formatCurrencyAmount(rootsessionuuid, currency.uuid, currency_amount, options);


		putAmount(amnt);
		setAmountString(currency_amount_string);
	}


	const putToAddress = (address, widgetuuid) => {
		setToAddress(address);

		// save in widget self
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		self.to_address = address;
	}

	const onToAddressChange = async (address) => {
		let start_conditions = theapp.getStartConditions();

		if (start_conditions && (start_conditions.to_address) && (start_conditions.to_address != address))
		return; // default has been set and can not be modified for security reasons

		// we can check it is a valid address

		putToAddress(address);
	}


	const putInvoiceId = (id, widgetuuid) => {
		setInvoiceId(id);

		// save in widget self
		let _widget_uuid = (widgetuuid ? widgetuuid : widget_uuid);

		let self = getWidgetSelf(theapp, WIDGET_NAME + _widget_uuid);

		self.invoice_id = id;
	}

	const onInvoiceIdChange = async (id) => {
		putInvoiceId(id);
	}



	const onAddTransactionData = async (data) => {

		if ((data === null) || (typeof data !== 'object'))
			return;

		let _tx_data = (tx_data ? tx_data : {});
		let bSave = false;

		// go through the keys
		let _keys = Object.keys(data);

		for (var i = 0; i < _keys.length; i++) {
			if (RESERVED_KEY_NAMES.includes(_keys[i]))
				continue; // reserved key words

			_tx_data[_keys[i]] = data[_keys[i]];
			bSave = true;
		}

		if (bSave)
		setTransactionData(_tx_data);
	}





	// rendering
	const renderLoading = () => {
		return (
			<div className="PaymentLinkWidgetBlock">
				<div>{theapp.t('loading widget...')}</div>
				<div className="PaymentLinkWidgetLoadingBlock">
					<Levels />
				</div>
			</div>
		);
	}

	const getStatusString = (status) => {
		switch(status) {
			case 10:
				return theapp.t('success');
			case 5:
				return theapp.t('pending');
			case -5:
				return theapp.t('not found');
			case -10:
				return theapp.t('fail');
			default:
				return theapp.t('unknown');
		} 
	}

	//
	// Small Size
	//
	const renderTransactionSmall = () => {
		return (
			<div className="sw-PaymentLinkWidgetBlock">

				<div className="sw-PaymentLinkRefreshIcon">
						<FontAwesomeIcon 
						icon={faSync}
						onClick={onRefresh}
						/>
				</div>

				<div className="sw-PaymentLinkAmountLine">
					<span><FormLabel>{theapp.t('Amount')}</FormLabel></span>
					<span className="sw-PaymentLinkAmountInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={tx_info.amount_string}
					/></span>
				</div>

				<div className="sw-PaymentLinkToAddressLine">
					<span><FormLabel>{theapp.t('Send to')}</FormLabel></span>
					<span className="sw-PaymentLinkToAddressInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={theapp.getMvcMyWidget().fitString(tx_info.to_address, 24)}
					/></span>
				</div>

				<div className="sw-PaymentLinkTxHashLine">
					<span><FormLabel>{theapp.t('TxHash')}</FormLabel></span>
					<span className="sw-PaymentLinkTxHashLink" onClick={onOpenExplorer}>{theapp.getMvcMyWidget().fitString(tx_info.hash, 28)}</span>
{/* 					<span className="sw-PaymentLinkTxHashInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={tx_info.hash}
					/></span> */}
				</div>
		
		
				<div className="sw-PaymentLinkTxStatusLine">
					<span><FormLabel>{theapp.t('Status')}</FormLabel></span>
					<span className="sw-PaymentLinkTxStatusInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={getStatusString(tx_info.status_int)}
					/></span>
					<span id="receipt-icon" className="sw-PaymentLinkTxReceiptIcon">
						<FontAwesomeIcon 
						icon={faSave}
						onClick={onDownloadReceipt}
						/>
					</span>

				</div>
		
				{(showlocalwallet ? 
				<div className="sw-PaymentLinkOpenWalletLine">
					<span className="sw-PaymentLinkOpenWalletIcon">
						<FontAwesomeIcon 
						icon={faCreditCard}
						onClick={onOpenWallet}
						/>
					</span>
				</div> :
				<></>)}

				<div className="sw-PaymentLinkVersionInfo" >{theapp.current_version}</div>
			</div>
		);
	}	

	const renderPaySmall = () => {
		// small-size widget = 4 lines
		return (
			<div className="sw-PaymentLinkWidgetBlock">
				<div className="sw-PaymentLinkAmountLine">
					<span><FormLabel>{theapp.t('Amount')}</FormLabel></span>
					<span className="sw-PaymentLinkAmountInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={amount_string}
					/></span>
				</div>

				<div className="sw-PaymentLinkInvoiceIdLine">
					<span><FormLabel>{theapp.t('Invoice Id')}</FormLabel></span>
					<span className="sw-PaymentLinkInvoiceIdInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={invoice_id}
					/></span>
				</div>

{/* 				<div className="sw-PaymentLinkToAddressLine">
					<span><FormLabel>{theapp.t('Send to')}</FormLabel></span>
					<span className="sw-PaymentLinkToAddressInput"><FormControl
						autoFocus
						type="text"
						value={to_address}
						onChange={e => onToAddressChange(e.target.value)}
					/></span>
				</div>
 */}

				{(showlocalwallet ? 
				<div className="sw-PaymentLinkOpenWalletLine">		
					<span className="sw-PaymentLinkOpenWalletIcon">
						<FontAwesomeIcon 
						icon={faCreditCard}
						onClick={onOpenWallet}
						/>
					</span>
				</div> :
				<div className="sw-PaymentLinkToAddressLine">
					<span><FormLabel>{theapp.t('Send to')}</FormLabel></span>
					<span className="sw-PaymentLinkToAddressInput"><FormControl
						disabled
						autoFocus
						type="text"
						value={theapp.getMvcMyWidget().fitString(to_address, 24)}
					/></span>
				</div>)}


				<div className="sw-PaymentLinkButtonLine">

					<Button  className="sw-PaymentLinkButton"
						onClick={onPay} 
						disabled={(isenabled ? false : true)}
						type="submit">
						{(!isprocessing ? theapp.t('Pay') : <Spinner />)} 
					</Button>
		
				</div>

				<div className="sw-PaymentLinkVersionInfo" >{theapp.current_version}</div>

			</div>
		
		);
	}
	
	const renderWidget = () => {
		switch(widgetsize) {
			default:
			return (tx_info ? renderTransactionSmall() : renderPaySmall());
		}
	}
	
	return (
		<div className="PaymentLinkWidget">
			{(isloading ? renderLoading() :
			renderWidget())}
		</div>
	);


}

export default PaymentLinkWidget;
